<template>
    <div class="form">
        <h4 class="step-title">
            <label for="YearHomeBought">When did you buy this home?</label>
        </h4>
        <div id="spinner-container" class="d-flex justify-content-center" v-if="loading">
            <div id="spinner" class="spinner-border text-light" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div class="step-content d-flex flex-column align-items-center" v-if="!loading">
            <scrollable-button-list v-bind:items="years" v-bind:onclick="complete" v-bind:value="lead.homeInsurance.yearHomeBought"/>
        </div>
    </div>
</template>

<script>
    import ScrollableButtonList from "../shared/ScrollableButtonList.vue"

    export default {
        name: "YearHomeBought",
        components: {
            ScrollableButtonList
        },
        data: function() {
            return {
                loading: false
            }
        },
        props: {
            lead: Object
        },
        computed: {
            years: function() {
                var years = [];
                var year = new Date().getFullYear();

                while(years.length < 200) {
                    years.push({ text: year, value: year });
                    year--;
                }

                return years;
            }
        },
        methods: {
            complete: function(value) {
                this.loading = true;
                this.lead.homeInsurance.yearHomeBought = value;
                this.$emit("complete", this.$options.name, value);
            }
        }
    }
</script>
